/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Calendar } from '../../models/calendar';

export interface ApiV0CalendarEventTypeCompanyIdCalendarPost$Json$Params {
  companyId: string;
      body?: Calendar
}

export function apiV0CalendarEventTypeCompanyIdCalendarPost$Json(http: HttpClient, rootUrl: string, params: ApiV0CalendarEventTypeCompanyIdCalendarPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Calendar>> {
  const rb = new RequestBuilder(rootUrl, apiV0CalendarEventTypeCompanyIdCalendarPost$Json.PATH, 'post');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Calendar>;
    })
  );
}

apiV0CalendarEventTypeCompanyIdCalendarPost$Json.PATH = '/api/v0/calendarEventType/{companyId}/calendar';
